export enum UserTypeEnum {
  SuperUser = 0,
  Admin = 1,
  Office = 2,
  Associate = 3,
  Client = 4
}

export interface UserDto {
  id: number;
  
  email: string;
  mobileNumber: string;

  title: string;
  fullName: string;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;

  positionDescription: string;

  isActive: boolean;
  isSuperUser: boolean;
  canUseAi?: boolean;
  isServiceAccount: boolean;

  userTypeId: UserTypeEnum;
  userType: string;
}
